import React, { useState, useEffect } from 'react'
import { StorageModule } from "../../modules/storage";
import axios from "axios";
import * as apis from '../../api/login';
import { getUrlParams } from '../../util'
import { userModule } from '../../modules/user'

interface Props {
    history: any;
}

interface State {
    urlParams: any
}

const Auth = (props: Props) => {
    const [state, setState] = useState<State>({
        urlParams: null
    })

    useEffect(() => {

        let _urlParams = getUrlParams(window.location.href);
        console.log("_urlParams", _urlParams)
        auth(_urlParams);
    }, [])
    const auth = async (urlParams: any) => {
        // 获取登录状态码
        try {
            const authResult: any = await apis.getExternalAuthResult(urlParams.state)
            console.log('authResult', authResult)
            if (authResult.ok) {
                // StorageModule.setToken(authResult.data.token);
                // axios.interceptors.request.use(
                //     (config) => {
                //         config.headers = { Authorization: authResult.data.token };
                //         return config;
                //     },
                //     (error) => {
                //         return Promise.reject(error);
                //     }
                // );
                const user = await userModule.setUserInfoByToken(authResult?.data.token);
                if (user) {
                    setTimeout(() => {
                        window.location.hash = '#/view'
                    }, 500)
                }
            } else {
                authErr()
            }
        } catch (err) {
            console.log("认证失败。。", err);
            authErr()
        }
    };
    const authErr = (urlParams?: any) => {
        console.log("认证失败");
        window.location.hash = '#/login'
    };
    return (
        <div>认证中…</div>
    )
}

export default Auth
